// Admin API client — /admin/messaging/* (mirrors the API's messaging aggregate).

import type {
  AdminThreadListResponse,
  ThreadDetailResponse,
  SupportThread,
  SupportMessage,
  AdminUnread,
  SendMessageRequest,
  UpdateThreadRequest,
  UploadUrlRequest,
  UploadUrlResponse,
} from '@a7y/types';
import { client } from './transport';

export const messagingApi = {
  // Messaging
  getMessagingThreads: (params?: {
    status?: string;
    limit?: number;
    startAfter?: string;
    search?: string;
  }) => {
    const searchParams = new URLSearchParams();
    if (params?.status) searchParams.set('status', params.status);
    if (params?.limit) searchParams.set('limit', String(params.limit));
    if (params?.startAfter) searchParams.set('startAfter', params.startAfter);
    if (params?.search) searchParams.set('search', params.search);
    return client.get<AdminThreadListResponse>(`/messaging/threads?${searchParams}`);
  },
  getMessagingThread: (threadId: string) =>
    client.get<ThreadDetailResponse>(`/messaging/threads/${threadId}`),
  sendMessagingReply: (threadId: string, request: SendMessageRequest) =>
    client.post<SupportMessage>(`/messaging/threads/${threadId}/messages`, request),
  updateMessagingThread: (threadId: string, request: UpdateThreadRequest) =>
    client.patch<SupportThread>(`/messaging/threads/${threadId}`, request),
  getMessagingUnread: () => client.get<AdminUnread>(`/messaging/unread`),
  markMessagingThreadRead: (threadId: string) =>
    client.post<void>(`/messaging/threads/${threadId}/read`),
  getMessagingUploadUrl: (request: UploadUrlRequest) =>
    client.post<UploadUrlResponse>(`/messaging/upload-url`, request),
};
